import React, { useMemo } from 'react';

import style from './run-tag.module.scss';

const RunRtTag = ({ rtNumber, rtName, selected = false }) => {
  const taskCardContainer = document.getElementById('task-card-main');
  const runNumberContainer = document.getElementById('rn-number');

  const rnNumberWidth = useMemo(() => {
    if (taskCardContainer && runNumberContainer) {
      return (
        (taskCardContainer?.clientWidth || 0) - (runNumberContainer?.clientWidth || 0) - 32 - 6 - 26
      );
    }
    return 100;
  }, [taskCardContainer, runNumberContainer]);

  return (
    <div className={style.statusDiv} style={{ ...(selected && { background: '#ffffff' }) }}>
      <span id="rn-number">{rtNumber}</span>

      <p className={style.pClass} style={{ maxWidth: `${rnNumberWidth}px` }}>
        {rtName}
      </p>
    </div>
  );
};

export default RunRtTag;
